import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  IconButton,
  styled,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import FilterBuilder from "../../Shared/FilterBuilder/FilterBuilder";
import { filterListByMongoQuery } from "../../Shared/FilterBuilder/FilterBuilder.clientFilter";
import SearchIcon from "@mui/icons-material/Search";
import { useExternalUsers } from "../../../graphql/Admins/query";
import {
  AdminStatus,
  getAdminStatus,
  getFormattedAdminStatus,
} from "../helpers";
import ExternalAdminStatushandler from "./ExternalAdminStatushandler";
import addAdmin from "../../../Photos/Newuiphotos/Admins/addAdmin.png";
import InternalAdminForm from "../InternalAdmins/InternalAdminForm";
import toast from "react-hot-toast";
import { ApolloError, useMutation, useQuery } from "@apollo/client";
import {
  GET_INDIVIDUALS_COUNT,
  GET_ORGANIZATIONS_COUNT,
} from "../../../graphql/queries";
import StatusHandlerModal from "../../Shared/StatusHandlerModal/StatusHandlerModal";
import { useAppThunkDispatch } from "../../../Redux/hooks";
import { ChangeSnackbar } from "../../../Redux/Actions/SnackbarActions/SnackbarActions";
import {
  UPDATE_USER_STATUS,
  USER_MASJID_ACTION,
} from "../../../graphql/Admins/mutation";
import { AddingNewAdminWithDescription } from "../../../Redux/Actions/AdminActions/AddingNewAdminWithDesc";
import moment from "moment";
import { Link } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import {
  getFormattedMasjidStatus,
  getStatus,
} from "../../PageComponents/MasjidTable/Helper";
import { Admin, AdminInterFace, CellDataType, Masjid } from "../../../../Types";
import ExternalTable from "./ExternalTable";
import MasjidStatusHandler from "../../PageComponents/MasjidTable/MasjidStatusHandler";
import { AdminRole } from "../../PageComponents/MasjidTable/Enums/enums";
import {
  formatRbacRoleLabel,
  getExternalAdminRoleLabel,
  isDelegatedSubAdmin,
  summarizePermissions,
} from "../../../helpers/rbacExternalAdmin";

interface Cooldowns {
  [key: string]: number;
}
const ExternalAdminsTable = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenForMasjid, setModalOpenForMasjid] = useState(false);
  const [logDetails, setLogDetails] = useState();

  const [searchText, setSearchText] = useState("");
  const [selectedAdminId, setSelectedAdminId] = useState("");
  const [selectedAdmin, setSelectedAdmin] = useState<AdminInterFace | null>(
    null
  );
  const [showAddForm, setShowAddForm] = useState(false);
  const [cooldowns, setCooldowns] = useState<Cooldowns | {}>({});
  const [selectedMasjid, setSelectedMasjid] = useState<Masjid | null>(null);
  const [entityDialogOpen, setEntityDialogOpen] = useState(false);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedEntityType, setSelectedEntityType] = useState<
    "MASJID" | "ORGANIZATION" | "INDIVIDUAL" | null
  >(null);
  const [selectedEntity, setSelectedEntity] = useState<any>(null);
  const [selectedRole, setSelectedRole] = useState<
    "all" | "masjid" | "musali" | "subAdmin" | "organization" | "individual"
  >("all");
  const [filterBuilderOpen, setFilterBuilderOpen] = useState(false);
  const [advancedFilter, setAdvancedFilter] = useState<string | null>(null);

  const [allAdmins, setAllAdmins] = useState<AdminInterFace[]>([]);
  const [masjidAdmins, setMasjidAdmins] = useState<AdminInterFace[]>([]);
  const [musaliAdmins, setMusaliAdmins] = useState<AdminInterFace[]>([]);
  const [organizationAdmins, setOrganizationAdmins] = useState<AdminInterFace[]>([]);
  const [individualAdmins, setIndividualAdmins] = useState<AdminInterFace[]>([]);
  const [subAdminAdmins, setSubAdminAdmins] = useState<AdminInterFace[]>([]);
  useEffect(() => {
    if (!modalOpenForMasjid) setSelectedMasjid(null);
  }, [modalOpenForMasjid]);

  useEffect(() => {
    // Only start timer if there are active cooldowns
    if (Object.keys(cooldowns).length === 0) {
      return;
    }

    // Set up an interval that runs every second
    const timerId = setInterval(() => {
      // Decrement each active admin's countdown
      setCooldowns((prev) => {
        const newCooldowns = {};
        let hasActiveCooldowns = false;

        // Loop over each adminId in prev
        Object.keys(prev).forEach((adminId: string) => {
          const secondsLeft = (prev as Cooldowns)[adminId];
          // If there's more than 1 second left, decrement.
          // If it hits 1 → 0, we simply omit that admin from newCooldowns
          if (secondsLeft > 1) {
            (newCooldowns as Cooldowns)[adminId] = secondsLeft - 1;
            hasActiveCooldowns = true;
          }
        });

        // If no active cooldowns remain, clear the interval
        if (!hasActiveCooldowns) {
          clearInterval(timerId);
        }

        return newCooldowns;
      });
    }, 1000);

    // Cleanup on unmount
    return () => clearInterval(timerId);
  }, [cooldowns]); // Add cooldowns as a dependency to restart timer when new cooldowns are added

  const dispatch = useAppThunkDispatch();
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const handleActionClick = useCallback(
    (action: string, details: AdminInterFace) => {
      setModalOpen(true);
      setSelectedAdminId(details._id);
      setSelectedAdmin(details);
    },
    []
  );
  const handleActionClickForMasjid = useCallback(
    (entityType: string, details: any) => {
      if (!details) return;
      if (entityType === "MASJID") {
        setSelectedMasjid(details as Masjid);
        setModalOpenForMasjid(true);
      } else {
        setSelectedEntityType(entityType as any);
        setSelectedEntity(details);
        setStatusModalOpen(true);
      }
    },
    []
  );
  const [
    updateAdminMasjid,
    {
      data: updateAdminMasjidData,
      loading: updateAdminMasjidLoading,
      error: updateAdminMasjidError,
    },
  ] = useMutation(USER_MASJID_ACTION);
  const { data, loading, error, refetch } = useExternalUsers();
  const {
    data: organizationsCountData,
    loading: organizationsCountLoading,
    error: organizationsCountError,
  } = useQuery(GET_ORGANIZATIONS_COUNT, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });
  const {
    data: individualsCountData,
    loading: individualsCountLoading,
    error: individualsCountError,
  } = useQuery(GET_INDIVIDUALS_COUNT, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (!organizationsCountError) return;
    console.error("Organization count query failed:", organizationsCountError);
    toast.error("Could not load organization totals. Showing count from this page.", {
      id: "external-org-count-error",
    });
  }, [organizationsCountError]);

  useEffect(() => {
    if (!individualsCountError) return;
    console.error("Individual count query failed:", individualsCountError);
    toast.error(
      "Could not load independent rep totals. Showing count from this page.",
      { id: "external-individual-count-error" }
    );
  }, [individualsCountError]);

  useEffect(() => {
    if (!loading) {
      if (error) {
        console.error("An error occurred while fetching admins:", error);
        toast.error("Failed to load admins. Please try again.");
      } else if (data && Array.isArray(data)) {
        setAllAdmins(data);

        // Filter Masjid admins - SUB_ADMIN role excluding ORGANIZATION and INDIVIDUAL
        setMasjidAdmins(
          data.filter((admin) => {
            const ownershipType = admin.ownershipType;
            return (
              admin.role === AdminRole.SUB_ADMIN &&
              ownershipType !== "ORGANIZATION" &&
              ownershipType !== "INDIVIDUAL"
            );
          })
        );

        // Filter Musali admins - MUSALI_ADMIN role excluding ORGANIZATION and INDIVIDUAL
        setMusaliAdmins(
          data.filter((admin) => {
            const ownershipType = admin.ownershipType;
            return (
              admin.role === AdminRole.MUSALI_ADMIN &&
              ownershipType !== "ORGANIZATION" &&
              ownershipType !== "INDIVIDUAL"
            );
          })
        );

        // Filter Organization and Individual admins by ownershipType
        setOrganizationAdmins(
          data.filter((admin) => admin.ownershipType === "ORGANIZATION")
        );

        setIndividualAdmins(
          data.filter((admin) => admin.ownershipType === "INDIVIDUAL")
        );

        // RBAC / invited feature admins (Sub-Admin tab)
        setSubAdminAdmins(data.filter((admin) => isDelegatedSubAdmin(admin)));
      }
    }
  }, [data, error, loading]);
  const handleAddAdmin = async (
    name: string,
    email: string,
    role: string,
    selectedMasjid: string | null
  ) => {
    let updatedData = {
      name: name,
      email: email.toLowerCase(),
      role: role,
      description: "",
      ownerType: "MASJID", // External admins are always for masjids
    };
    console.log(updatedData, selectedMasjid);

    try {
      const toastId = toast.loading("Adding Admin...");
      const result = await dispatch(AddingNewAdminWithDescription(updatedData));
      if (!result._id) {
        console.log("error occured");
        toast.dismiss(toastId);
        toast.error("Error adding admin");
        return;
      } else if (selectedMasjid) {
        const adminMasjidData = {
          userId: result._id,
          masjidId: selectedMasjid,
          action: "assign",
        };
        updateAdminMasjid({ variables: adminMasjidData })
          .then((resultUpdateMasjid) => {
            if (!resultUpdateMasjid?.data?.userMasjidAction) {
              throw new Error("Error adding masjid to admin");
            } else {
              console.log("Added masjid to admin:", resultUpdateMasjid);

              const snackbarSuccessDetails = {
                snackbarOpen: true,
                snackbarType: "success",
                snackbarMessage:
                  "Admin credentials have been sent to the admin",
              };
              toast.dismiss();
              dispatch(ChangeSnackbar(snackbarSuccessDetails));
              refetch();
            }
          })
          .catch((error) => {
            refetch();
            console.log("Error adding masjid to admin:", error);

            let errorMessage = "Error assigning masjid to admin.";
            if (error instanceof ApolloError && error.graphQLErrors.length) {
              errorMessage = error.graphQLErrors[0].message;
            }

            const snackbarFailureDetails = {
              snackbarOpen: true,
              snackbarType: "error",
              snackbarMessage: errorMessage,
            };
            toast.dismiss(toastId);
            dispatch(ChangeSnackbar(snackbarFailureDetails));
          });
      } else {
        const snackbarSuccessDetails = {
          snackbarOpen: true,
          snackbarType: "success",
          snackbarMessage: "Admin credentials have been sent to the admin",
        };
        dispatch(ChangeSnackbar(snackbarSuccessDetails));
        refetch();
        toast.dismiss(toastId);
      }
    } catch (err) {
      console.error("Error adding admin:", err);
      const snackbarFailureDetails = {
        snackbarOpen: true,
        snackbarType: "error",
        snackbarMessage: "Error adding admin",
      };
      toast.dismiss();
      dispatch(ChangeSnackbar(snackbarFailureDetails));
    }
  };
  const displayedData = useMemo(() => {
    if (selectedRole === "masjid") return masjidAdmins;
    if (selectedRole === "musali") return musaliAdmins;
    if (selectedRole === "subAdmin") return subAdminAdmins;
    if (selectedRole === "organization") return organizationAdmins;
    if (selectedRole === "individual") return individualAdmins;
    return allAdmins;
  }, [
    selectedRole,
    masjidAdmins,
    musaliAdmins,
    subAdminAdmins,
    organizationAdmins,
    individualAdmins,
    allAdmins,
  ]);

  const organizationTotalFromApi =
    organizationsCountData?.totalOrganizations?.total;
  const individualTotalFromApi = individualsCountData?.totalIndividuals?.total;

  const organizationCountFallback = organizationAdmins.length;
  const individualCountFallback = individualAdmins.length;

  /** Resolved count for cards: API total when available; on error, list length; while loading with no cache, null → spinner */
  const organizationCardCount = organizationsCountError
    ? organizationCountFallback
    : organizationTotalFromApi ?? organizationCountFallback;
  const individualCardCount = individualsCountError
    ? individualCountFallback
    : individualTotalFromApi ?? individualCountFallback;

  const organizationCountPending =
    organizationsCountLoading &&
    organizationTotalFromApi === undefined &&
    !organizationsCountError;
  const individualCountPending =
    individualsCountLoading &&
    individualTotalFromApi === undefined &&
    !individualsCountError;

  // Helper function to normalize text for search (remove special characters)
  const normalizeText = (text: string): string => {
    return text
      .toLowerCase()
      .replace(/[^\w\s]/g, " ") // Remove all special characters except word characters and spaces
      .replace(/\s+/g, " ") // Replace multiple spaces with single space
      .trim();
  };

  const filteredData: AdminInterFace[] | [] = useMemo(() => {
    if (!displayedData?.length) return [];
    return displayedData
      .filter((row: AdminInterFace) => {
        const searchTerm = normalizeText(searchText);
        const adminStatus = normalizeText(
          getFormattedAdminStatus(
            getAdminStatus(row?.isFreezed, row?.isVerified)
          )
        );

        // Check if masjidDetails exists and has at least one element
        const hasMasjidDetails =
          row?.masjidDetails && row.masjidDetails.length > 0;
        const masjidVerification = hasMasjidDetails
          ? normalizeText(
              getFormattedMasjidStatus(
                getStatus(
                  row.masjidDetails[0]?.isFreezed,
                  row.masjidDetails[0]?.isVerified
                )
              )
            )
          : "";

        // Normalize all searchable fields
        const normalizedEmail = normalizeText(row.email || "");
        const normalizedName = normalizeText(row.name || "");
        const normalizedMasjidName = hasMasjidDetails
          ? normalizeText(row.masjidDetails[0]?.masjidName || "")
          : "";
        const normalizedRole = normalizeText(getExternalAdminRoleLabel(row));
        const normalizedContact = normalizeText(row.contact || "");

        const rbacSearchMatch =
          selectedRole === "subAdmin"
            ? (() => {
                const normalizedRbac = normalizeText(
                  formatRbacRoleLabel(row)
                );
                const { summary: permSummary } = summarizePermissions(
                  row.permissions
                );
                const normalizedPerms = normalizeText(permSummary);
                const normalizedPermissionRole = normalizeText(
                  row.permissionRole || ""
                );
                return (
                  normalizedRbac.includes(searchTerm) ||
                  normalizedPerms.includes(searchTerm) ||
                  normalizedPermissionRole.includes(searchTerm)
                );
              })()
            : false;

        return (
          normalizedEmail.includes(searchTerm) ||
          normalizedName.includes(searchTerm) ||
          normalizedMasjidName.includes(searchTerm) ||
          normalizedRole.includes(searchTerm) ||
          rbacSearchMatch ||
          normalizedContact.includes(searchTerm) ||
          adminStatus.includes(searchTerm) ||
          masjidVerification.includes(searchTerm)
        );
      })
      .sort((a: AdminInterFace, b: AdminInterFace) => {
        // Assign groups based on conditions
        // const groupA = getGroupPriority(a);
        // const groupB = getGroupPriority(b);

        // Compare group priority first
        // if (groupA !== groupB) {
        //   return groupA - groupB;
        // }

        // If in the same group, sort by createdAt
        return (
          new Date(b.createdAt as string).getTime() -
          new Date(a.createdAt as string).getTime()
        );
      });
  }, [displayedData, searchText, selectedRole]);

  const dataForTable = useMemo(() => {
    if (!advancedFilter) return filteredData;
    try {
      return filterListByMongoQuery(filteredData, advancedFilter);
    } catch (error) {
      console.error("Invalid filter query:", error);
      return filteredData;
    }
  }, [filteredData, advancedFilter]);

  // Helper function to assign group priority
  function getGroupPriority(item: AdminInterFace) {
    if (!item.isFreezed && (!item.isApproved || !item.isVerified)) {
      return 1; // Group 1: isFreezed = false, isApproved or isVerified = false
    }
    if (!item.isFreezed && item.isApproved && item.isVerified) {
      return 2; // Group 2: isFreezed = false, isApproved and isVerified = true
    }
    return 3; // Group 3: isFreezed = true
  }
  return (
    <Box
      sx={{
        flexGrow: 1,
        padding: 3,
      }}
    >
      <Card sx={{ mt: 3, backgroundColor: "transparent", boxShadow: "none" }}>
        <Grid container spacing={3} sx={{ mb: 3 }}>
          {/* 1) All Admins */}
          <Grid item xs={2} onClick={() => setSelectedRole("all")}>
            <Card
              sx={{
                borderRadius: "22px",
                border: selectedRole === "all" ? "2px solid #1B8368" : "none",
                boxShadow:
                  selectedRole === "all"
                    ? "none"
                    : "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  color="#1B8368"
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  All Admins
                </Typography>
                <Typography
                  variant="h5"
                  color="#1B8368"
                  sx={{ fontWeight: "bold" }}
                >
                  {allAdmins.length.toString().padStart(2, "0")}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          {/* 2) Admin */}
          <Grid item xs={2} onClick={() => setSelectedRole("masjid")}>
            <Card
              sx={{
                borderRadius: "22px",
                border:
                  selectedRole === "masjid" ? "2px solid #1B8368" : "none",
                boxShadow:
                  selectedRole === "masjid"
                    ? "none"
                    : "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  color="#1B8368"
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  Masjid Admin
                </Typography>
                <Typography
                  variant="h5"
                  color="#1B8368"
                  sx={{ fontWeight: "bold" }}
                >
                  {masjidAdmins.length.toString().padStart(2, "0")}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* 3) Musali Admin */}
          <Grid item xs={2} onClick={() => setSelectedRole("musali")}>
            <Card
              sx={{
                borderRadius: "22px",
                border:
                  selectedRole === "musali" ? "2px solid #1B8368" : "none",
                boxShadow:
                  selectedRole === "musali"
                    ? "none"
                    : "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  color="#1B8368"
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  Musali Admin
                </Typography>
                <Typography
                  variant="h5"
                  color="#1B8368"
                  sx={{ fontWeight: "bold" }}
                >
                  {musaliAdmins.length.toString().padStart(2, "0")}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* 4) Sub-Admin (RBAC / feature delegates) */}
          <Grid item xs={2} onClick={() => setSelectedRole("subAdmin")}>
            <Card
              sx={{
                borderRadius: "22px",
                border:
                  selectedRole === "subAdmin" ? "2px solid #1B8368" : "none",
                boxShadow:
                  selectedRole === "subAdmin"
                    ? "none"
                    : "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  color="#1B8368"
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  Sub-Admin
                </Typography>
                <Typography
                  variant="h5"
                  color="#1B8368"
                  sx={{ fontWeight: "bold" }}
                >
                  {subAdminAdmins.length.toString().padStart(2, "0")}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* 5) Organization */}
          <Grid item xs={2} onClick={() => setSelectedRole("organization")}>
            <Card
              sx={{
                borderRadius: "22px",
                border: selectedRole === "organization" ? "2px solid #1B8368" : "none",
                boxShadow:
                  selectedRole === "organization"
                    ? "none"
                    : "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  color="#1B8368"
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  Organization
                </Typography>
                {organizationCountPending ? (
                  <CircularProgress size={28} sx={{ color: "#1B8368", mt: 0.5 }} />
                ) : (
                  <Tooltip
                    title={
                      organizationsCountError
                        ? "Server total unavailable; this number matches admins loaded on this page."
                        : ""
                    }
                    disableHoverListener={!organizationsCountError}
                  >
                    <Typography
                      component="span"
                      variant="h5"
                      color="#1B8368"
                      sx={{ fontWeight: "bold" }}
                    >
                      {organizationCardCount.toString().padStart(2, "0")}
                    </Typography>
                  </Tooltip>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* 6) Individual */}
          <Grid item xs={2} onClick={() => setSelectedRole("individual")}>
            <Card
              sx={{
                borderRadius: "22px",
                border: selectedRole === "individual" ? "2px solid #1B8368" : "none",
                boxShadow:
                  selectedRole === "individual"
                    ? "none"
                    : "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  color="#1B8368"
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  Independent Reps
                </Typography>
                {individualCountPending ? (
                  <CircularProgress size={28} sx={{ color: "#1B8368", mt: 0.5 }} />
                ) : (
                  <Tooltip
                    title={
                      individualsCountError
                        ? "Server total unavailable; this number matches admins loaded on this page."
                        : ""
                    }
                    disableHoverListener={!individualsCountError}
                  >
                    <Typography
                      component="span"
                      variant="h5"
                      color="#1B8368"
                      sx={{ fontWeight: "bold" }}
                    >
                      {individualCardCount.toString().padStart(2, "0")}
                    </Typography>
                  </Tooltip>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "white",
          }}
        >
          <TextField
            fullWidth
            placeholder="Search"
            value={searchText}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <IconButton>
                  <SearchIcon sx={{ fontSize: "25px" }} />
                </IconButton>
              ),
            }}
            sx={{
              margin: "20px",
              width: "80%",
              borderRadius: "30px", // Add this line to increase the border radius
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Add shadow here
              borderColor: "#565656",
              "& .MuiOutlinedInput-root": {
                borderRadius: "30px", // Ensure the input field's border radius is updated
              },
              "& .MuiOutlinedInput-notchedOutline": {
                // borderColor: "#565656",
              },
            }}
            variant="outlined"
          />

          <Button
            variant="outlined"
            sx={{
              color: "#1B8368",
              borderColor: "#1B8368",
              borderWidth: "2px",
              height: "fit-content",
              borderRadius: "20px",
              textTransform: "none",
              fontWeight: "bold",
              marginRight: "20px",
              textWrap: "nowrap",
              padding: "8px 12px",
              width: "auto",
              ":hover": {
                borderColor: "#1B8368",
                borderWidth: "2px",
              },
            }}
            onClick={() => {
              setSelectedAdmin(null);
              setShowAddForm(true);
            }}
          >
            <Box
              component="img"
              src={addAdmin}
              sx={{ width: "20px", marginRight: "8px" }}
            />
            Add New Admin
          </Button>
        </Box>
        <div
          style={{
            height: loading ? "650px" : "1200px",
            width: "100%",
            overflow: "auto",
          }}
        >
          <ExternalTable
            loading={loading}
            filteredData={dataForTable}
            handleActionClick={handleActionClick}
            handleActionClickForMasjid={handleActionClickForMasjid}
            onOpenAdvancedFilter={() => setFilterBuilderOpen(true)}
            hasActiveFilter={!!advancedFilter}
            subAdminTab={selectedRole === "subAdmin"}
          />
        </div>
      </Card>
      {modalOpen && (
        <ExternalAdminStatushandler
          cooldowns={cooldowns}
          setCooldowns={setCooldowns}
          selectedAdmin={selectedAdmin}
          setSelectedAdmin={setSelectedAdmin}
          open={modalOpen}
          onClose={() => {}}
          setOpen={setModalOpen}
          isLoading={false}
          refetch={refetch}
        />
      )}

      <InternalAdminForm
        open={showAddForm}
        onClose={() => {
          setShowAddForm(false);
        }}
        handleSubmit={(name, email, contact, role, selectedMasjid, isEdit) => {
          console.log(
            "handleSubmit",
            name,
            email,
            contact,
            role,
            selectedMasjid,
            isEdit
          );
          setShowAddForm(false);
          // Directly call handleAddAdmin with parameters
          handleAddAdmin(name, email, role, selectedMasjid);
        }}
        adminType="external"
      />
      <MasjidStatusHandler
        refetch={refetch}
        open={modalOpenForMasjid}
        setOpen={setModalOpenForMasjid}
        onConfirm={() => {}}
        selectedMasjid={selectedMasjid as Masjid}
        setSelectedMasjid={setSelectedMasjid}
      />

      <StatusHandlerModal
        open={statusModalOpen}
        onClose={() => setStatusModalOpen(false)}
        entity={selectedEntity}
        entityType={(selectedEntityType as any) || "ORGANIZATION"}
        onStatusUpdate={() => {
          refetch();
        }}
      />
      <FilterBuilder
        entityType="ADMIN"
        open={filterBuilderOpen}
        onClose={() => setFilterBuilderOpen(false)}
        onApply={(filter) => setAdvancedFilter(filter)}
        pageId="external-admins-table"
      />
    </Box>
  );
};

export default ExternalAdminsTable;
